import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
export default {
    cekTerminKomplit(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const {
                //     data
                // } = await axios.get(`/procure/cekTerminKomplit/${obj.po}/${obj.termin}/${obj.apinvkey || ''}`);

                const keys = ['po', 'termin', 'apinvkey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/procure/cekTerminKomplit${str}`;
                const { data } = await axios.get(url);    
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`apinvrequest/detail/${obj.apinvkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    paymenthistory(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`apinvrequest/detailsettle/${obj.apinvkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'invoice', 'vendor','vendorcode', 'po', 'postgroup', 'posting', 'tagihandp','receivingposting', 'statuswf', 'iDocsURL'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/apinvrequest/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'apinvrequest.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },
    findcoa(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`coa/findcoa/${obj.kodeacc}/${obj.tahun}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    getcoa(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`coa/getcoa/${obj.tahun}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    insert(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("apinvrequest", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    saveinfo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("apinvrequest/saveinfo", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    savenpost(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // await axios.post("apinvrequest/savenpost", obj);
                const { data } = await axios.post("apinvrequest/savenpost", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'invoice', 'vendor', 'vendorcode', 'po', 'postgroup', 'posting', 'tagihandp','receivingposting', 'statuswf', 'iDocsURL'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
            }
                const url = `/apinvrequest${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    listtax(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'invoice', 'vendor', 'vendorcode', 'po', 'postgroup', 'posting', 'tagihandp','receivingposting'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
            }
                const url = `/apinvrequest/listtax${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    listtaxexportxls(obj = {}) {
        const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'invoice', 'vendor','vendorcode', 'po', 'postgroup', 'posting', 'tagihandp','receivingposting'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/apinvrequest/listtaxexportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'apinvrequest.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },
    
    getUangmuka(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['vendor_id', 'matauang', 'po', 'apinvkey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
            }
                const url = `/apinvrequest/uangmuka${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    cekUangmukaCukup(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const dpTerpilih = obj.dpTerpilih;
                for (let index = 0; index < dpTerpilih.length; index++) {
                    const dp = dpTerpilih[index];
                    const { data } = await axios.get('/apinvrequest/uangmukacukup?dpapinvkey=' + encodeURIComponent(dp.apinvkey) + '&apinvkey=' + encodeURIComponent(obj.apinvkey));
                    if (dp.nilai > data.sisaDP) {
                        resolve(false);
                    }
                }
                resolve(true);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },      
    groupdp() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/apinv/groupdp");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    pasalpph() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/apinv/pasalpph");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/apinv/postgroup");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    prepaidexp() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/groupakun/prepaidexp");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    

    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.apinvkey);
                url = `/apinvrequest/print`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`apinvrequest/${obj.apinvkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    idocs(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`apinvrequest/idocs/${obj.apinvkey}`,obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    iDocURI() {
        // const instance = axios.create({
        //     baseURL: 'https://idocs.metrotvnews.tv/api/docfin/browse/',
        //     header:{Authorization: 'Basic Y2VQb0lCWHd2Z3RId3JaSDh0OWw3a1g4Y2JjNFRJQmI6OTE3T1FDd3BGSVc4QkhYcFlXZlg3TXp4bjByMUw3Mmk='},
        //   });
        // const instance = axios.create({
        //     baseURL: 'https://idocs.metrotvnews.tv/api/docfin',
        //     auth: {username : 'cePoIBXwvgtHwrZH8t9l7kX8cbc4TIBb' , password : '917OQCwpFIW8BHXpYWfX7Mzxn0r1L72i'}
        //   });
        // return instance.getURI({url:'/browse'});

        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.get(`/browse`,{
                        baseURL: 'https://idocs.metrotvnews.tv/api/docfin',
                        auth: {username : 'cePoIBXwvgtHwrZH8t9l7kX8cbc4TIBb' , password : '917OQCwpFIW8BHXpYWfX7Mzxn0r1L72i'}
                      });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });

    },
    actionhistory(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/apinvrequest/actionhistory/${obj.apinvkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('File Name : ', formData.filename);
                const { data } = await axios.post("apinvrequest/send2wf", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/apinvrequest/send2wfCancel/${obj.apinvkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

};